module.exports = __webpack_public_path__ + "static/media/facileristrutturare-bg.b2761619.jpg";